<template>
  <v-app>
    <v-content>
      <v-container class="fill-height" style="background: #f5f5f5" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="6">
            <div class="text-center mb-5">
              <img :src="logo" alt="Logo" width="150" />
            </div>

            <v-card
              class="elevation-2 pa-5"
              style="border-radius: 25px"
              :disabled="loading"
            >
              <v-card-text class="mt-5">
                <h2 class="text-center grey--text text--darken-3">
                  Acesse sua conta
                </h2>
                <h4 class="text-center grey--text text--darken-3 mt-3">
                  Entre com seu e-mail e senha cadastrados
                </h4>
                <v-row align="center" justify="center" class="mt-5">
                  <v-col cols="12" sm="12" md="8">
                    <v-form ref="form" @submit.prevent="login()">
                      <v-text-field
                        v-model="form.email"
                        label="Email"
                        type="email"
                        prepend-icon="mdi-email"
                        class="mt-2"
                        color="teal"
                        :rules="[rules.required]"
                        autofocus
                      />
                      <v-text-field
                        v-model="form.senha"
                        label="Senha"
                        :type="showSenha ? 'text' : 'password'"
                        prepend-icon="mdi-lock"
                        class="mt-5"
                        color="teal"
                        :rules="[rules.required]"
                      >
                        <template v-slot:append>
                          <v-icon
                            class="mr-2"
                            style="bottom: 5px"
                            :title="showSenha ? 'Ocultar Senha' : 'Mostrar Senha'"
                            @click="showSenha = !showSenha"
                          >
                            {{ showSenha ? 'mdi-eye-off' : 'mdi-eye' }}
                          </v-icon>
                          <router-link :to="'/recovery'" class="grey--text text--darken-2" style="text-decoration: none; font-size: 10.5pt">
                            Esqueci minha senha
                          </router-link>
                        </template>
                      </v-text-field>

                      <div class="text-center">
                        <div class="mt-5">
                          <v-btn
                            color="red"
                            rounded
                            dark
                            large
                            style="width: 200px"
                            type="submit"
                            :loading="loading"
                          >
                            <v-icon left>mdi-login</v-icon>
                            Entrar
                          </v-btn>
                        </div>

                        <div class="mt-10" style="font-size: 12pt">
                          <span class="grey--text text--darken-3 mr-2"
                            >Ainda não possui uma conta?</span
                          >
                          <router-link :to="'/register'"
                            >Clique aqui para se cadastrar!</router-link
                          >
                        </div>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import rules from "@/utils/rules";
import Auth from "@/services/auth";

export default {
  name: "Login",

  data() {
    return {
      loading: false,
      logo: "/img/Logo.png",
      rules: rules,

      form: {
        email: this.$storage.get("user-login"),
        senha: ''
      },

      showSenha: false
    }
  },

  methods: {
    async login() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;
      this.$storage.set("user-login", this.form.email);
      try {
        const result = await new Auth().login(this.form.email, this.form.senha);
        this.$router.push("/");
      } catch (error) {
        console.error(error);
        this.$swal.error("", error);
        this.form.senha = "";
      } finally {
        this.loading = false;
      }
    }
  },

  mounted() {
    this.$analytics.setCurrentScreen("web/Login");
  }
};
</script>
